import { useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import {
  logger,
  PhoneNumberForm,
  PhoneNumberFormikConfig,
  PhoneNumberScreen,
  userContext,
  useTheme,
} from "capsule"
import _ from "lodash"
import React, { useCallback, useContext, useEffect, useMemo } from "react"
import { StyleSheet, View } from "react-native"

import { DoctupSupportedCountries, INPUT_HEIGHT, MAX_AGE } from "../../features/config/Constants"
import currentDateMs from "../../features/hooks/useDateMock"
import { updateUserData } from "../../features/models/UserDataFunctions"
import { RootParamList } from "../../features/Navigation/types"
import { getFlagEmoji } from "../../utils/conversion"

const MfaScreen = () => {
  const {
    dimensions: { spacing },
    colors: {
      surface: { background },
    },
  } = useTheme()
  const { user, userDocRef } = useContext(userContext)
  const navigation = useNavigation<StackNavigationProp<RootParamList, "MfaValidation">>()

  const countriesAndFlagsArray = useMemo(
    () =>
      _.map(DoctupSupportedCountries, country => ({
        code: country.countryCode,
        title: country.countryName,
        flag: getFlagEmoji(country.countryCode),
        callingCode: country.countryCallingCode,
      })),
    [],
  )

  const onSubmit = useCallback(
    async (form: PhoneNumberForm) => {
      try {
        await updateUserData(userDocRef, { phoneNumber: form.phoneNumber })
        navigation.navigate("MfaValidation", {
          phoneNumber: form.phoneNumber,
        })
      } catch (e) {
        logger(e)
      }
    },
    [navigation, userDocRef],
  )

  const { inputStyle, langageBtnStyle, dropdownBtnStyle, phoneInputContainer, view } = useMemo(
    () => ({
      inputStyle: styles.input,
      langageBtnStyle: styles.langageButton,
      dropdownBtnStyle: styles.dropdownButton,
      phoneInputContainer: [styles.phoneInputContainer, { marginTop: spacing * 2 }],
      view: [styles.view, { backgroundColor: background }],
    }),
    [spacing, background],
  )
  useEffect(() => {
    if (user?.metadata.lastSignInTime) {
      const lastSignIn = new Date(user.metadata.lastSignInTime).getTime()
      const now = currentDateMs()

      const ageMs = now - lastSignIn
      if (ageMs > MAX_AGE) {
        navigation.navigate("MfaRegister")
      }
    }
  }, [navigation, user?.metadata.lastSignInTime])

  return (
    <View style={view}>
      <PhoneNumberScreen<PhoneNumberForm>
        countries={countriesAndFlagsArray}
        name="phoneNumber"
        {...{ inputStyle, langageBtnStyle, dropdownBtnStyle, phoneInputContainer }}
        formikConfig={PhoneNumberFormikConfig<PhoneNumberForm>(onSubmit)}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  phoneInputContainer: {
    flex: 1,
    justifyContent: "space-between",
    flexDirection: "row",
  },
  input: {
    height: INPUT_HEIGHT,
    flexBasis: "72%",
  },
  langageButton: {
    flexBasis: "25%",
    backgroundColor: "rgba(33, 33, 33, 0.05)",
  },
  dropdownButton: {
    width: "50%",
  },
  view: {
    flex: 1,
  },
})

export default MfaScreen
